import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  useQuery,
  useManualQuery,
  useMutation,
  ClientContext,
} from "graphql-hooks";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Grid,
  Paper,
  List,
  Checkbox,
  IconButton,
  Card,
  CardContent,
  Box,
  Divider,
  TextField,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Tabs, Tab } from "@mui/material";
import { Link } from "@mui/material";
import styled from "styled-components";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import { 
  REFRESH_TOKEN_MUTATION,
  TENANT_USER_LIST_BY_TERM_TEAM, STAFF_MODULE_ACCESS_QUERY
} from "../../graphQL/user_qry";
import AssignedTeamDialog from "./AssignedTeamDialog.js";
import EditTeamGoalDialog from "./EditTeamGoalDialog.js";

import { GET_TERM_DATA_BY_TERM_UUID } from "../../graphQL/term_qry";
import { GET_ALL_TEAMS_QUERY } from "../../graphQL/team_qry";
import { 
  GET_ALL_TEAMS_IN_TERM_QUERY,
  CREATE_TEAM_TERM_MUTATION
} from "../../graphQL/team_term_qry"
import { TENANT_ALL_ROLES_QUERY } from "../../graphQL/tenantRole"
import { ALL_USER_TYPES_QUERY } from "../../graphQL/user_type_qry"
import { 
  GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY,
  CREATE_TEAM_TERM_MEMBER_MUTATION,
  DELETE_TEAM_TERM_MEMBER_MUTATION,
  EDIT_TEAM_TERM_MEMBER_MUTATION,
} from "../../graphQL/team_term_member_qry"
import { 
  
  CLIENT_MEMBER_LIST_BY_TERM_TEAM
} from "../../graphQL/clientMember"

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled((props) => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -45px, 20px, -35px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    paddingBottom: 16,
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  section: {
    padding: "20px",
  },
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#0D47A1",
    },
  },
  checkbox: {
    padding: "0px",
    margin: "10px 10px",
  },
  arrowButton: {
    margin: "0 10px",
    "&:hover": {
      backgroundColor: "#1E88E5",
      color: "#fff",
      border: "none",
    },
  },
  card: {
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(0, 0, 0, 0.1)",
    paddingTop: "20px",
    minHeight: "450px",
    borderRadius: "8px",
  },
  cardContent: {
    padding: "0px",
  },
  teamTabs: {
    borderBottom: "1px solid #ddd",
    paddingLeft: 50,
    paddingRight: 50,
    "& .MuiSvgIcon-root": {
      fontSize: "30px",
      "&:hover": {
        backgroundColor: "#1E88E5",
        color: "#fff",
        border: "none",
        borderRadius: "100%",
      },
    },
  },
  tabs: {
    color: "#000000de",
    "&.Mui-selected": {
      color: "#0D47A1",
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
  },
  resourceTabs: {
  //  color: "#000000de",  
    "&.Mui-selected": {
      color: "#0D47A1",
      backgroundColor: "#E2F2FF",
    },
  },
  tab: { fontWeight: 600 },
  autoComStyle: {
    paddingRight: 16,
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 10,
    },
  },
  teamGoalTextStyle: {
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 14,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    lineHeight: 1.2,
    wordBreak: "break-word",
    minWidth: 100,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  teamGoalTextBoxStyle: {
    height: 50,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    paddingRight: 10,
    minWidth: 200,
  },
  teamGoalLabelTextStyle: {
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 16,
    fontWeight: 600,
    display: "flex",
    padding: 5,
    // paddingRight: 10,
    alignItems: "center",
    textAlign: "left",
    minWidth: 85
  },  
}));

const TeamsAssignment = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { termUuid } = useParams();
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const [selectedTeamTab, setSelectedTeamTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState("members");
  const [alertMsg, setAlertMsg] = useState([]);
  const [openListOfTeamDlg, setOpenListOfTeamDlg] = useState(null);
  const [saveToTermDone, setSaveToTermDone] = useState(false);

  const [teamGoal, setTeamGoal] = useState("");
  const [openEditTeamGoalDialog, setOpenEditTeamGoalDialog] = useState(false);

  const [membersData, setMembersData] = useState([]);
  const [staffData, setStaffData] = useState([]);

  const [termName, setTermName] = useState("");
  const [termInfo, setTermInfo] = useState([]);
  const [teamTabData, setTeamTabData] = useState([]);
  const [roleData, setRoleData] = useState([]);
  const [allUserTypes, setAllUserTypes] = useState([]);
  const [clrResourceFlag, setClrResourceFlag] = useState(false);
  const [allResourceInTeamTerm, setAllResourceInTeamTerm] = useState([]);

   
  const [assignTeamsAccess, setAssignTeamsAccess] = useState(true);

  const [pathname] = useState(window.location.pathname);
  const [membersErrors, setMembersErrors] = useState({});
  const [staffErrors, setStaffErrors] = useState({});
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: (err) => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem(
        "refreshToken",
        refreshData.refreshToken.refreshToken
      );
      client.setHeader(
        "Authorization",
        `JWT ${refreshData.refreshToken.token}`
      );
      setLoadContent(true);
    }
  };

  let clientId = 0;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName"))
    clientName = localStorage.getItem("clientName");
  let tenantId = 0;
  if (localStorage.getItem("tenantId"))
    tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  
  const [getTermDataQuery] = useManualQuery(GET_TERM_DATA_BY_TERM_UUID);
  const [getClinetTeamsList] = useManualQuery(GET_ALL_TEAMS_QUERY);
  const [getTeamTermList] = useManualQuery(GET_ALL_TEAMS_IN_TERM_QUERY);
  const [getTenantRoleList] = useManualQuery(TENANT_ALL_ROLES_QUERY);
  const [getUserTypesList] = useManualQuery(ALL_USER_TYPES_QUERY);
  const [getTeamTermMembers] = useManualQuery(GET_ALL_MEMBERS_IN_TEAM_TERM_QUERY);
  const [getClientMembers] = useManualQuery(CLIENT_MEMBER_LIST_BY_TERM_TEAM);
  const [getTenantUsers] = useManualQuery(TENANT_USER_LIST_BY_TERM_TEAM);
  const [createTeamTerm] = useMutation(CREATE_TEAM_TERM_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [createTeamTermMember] = useMutation(CREATE_TEAM_TERM_MEMBER_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [editTeamTermMember] = useMutation(EDIT_TEAM_TERM_MEMBER_MUTATION, {
    awaitRefetchQueries: true,
  });
  const [deleteTeamTermMember] = useMutation(DELETE_TEAM_TERM_MEMBER_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Terms",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let additionalActions = accessData.staffModuleAccess.additionalActions.split('|');
      
      
      if(additionalActions.find(a => a == "Assign Teams")){
        setAssignTeamsAccess(true);}
      else setAssignTeamsAccess(false)


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);



  useEffect(() => {
    (() => getTenantRoles())();
  }, []);

  useEffect(() => {
    (() => getAllUserTypes())();
  }, []);

  useEffect(() => {
    (() => getTermData())();
  }, []);

  useEffect(() => {
    (() => getTeamslist())();
  }, [termInfo]);

  useEffect(() => {
    (() => getClientMembersList())();
  }, [teamTabData, selectedTeamTab]);

  useEffect(() => {
    (() => getTenantUsersList())();
  }, [teamTabData, selectedTeamTab]);

  useEffect(() => {
    (() => getTeamTermMemberList())();
  }, [teamTabData, selectedTeamTab]);

  const getTenantRoles = async () => {
    if (tenantId){
      const {
        loading: loadingTenantRoleData,
        error: errorTenantRoleData,
        data: dataTenantRoleData,
      } = await getTenantRoleList({
        variables: {
          tenantId: parseInt(tenantId),
        },
      });
      if (!loadingTenantRoleData && 
        dataTenantRoleData && 
        dataTenantRoleData.tenantAllRoleList) {
        setRoleData(dataTenantRoleData.tenantAllRoleList);
      };
    };
  };

  const getAllUserTypes = async () => {
    const {
      loading: loadingUserTypesData,
      error: errorUserTypesData,
      data: dataUserTypesData,
    } = await getUserTypesList();
    if (!loadingUserTypesData && 
      dataUserTypesData && 
      dataUserTypesData.allUserTypesList) {
      setAllUserTypes(dataUserTypesData.allUserTypesList);
    };
  };

  const getTeamTermMemberList = async () => {
    if (teamTabData.length &&
        teamTabData[selectedTeamTab] &&
        teamTabData[selectedTeamTab].teamTermId)
    {
      const {
        loading: loadingTeamTermMembers,
        error: errorTeamTermMembers,
        data: dataTeamTermMembers,
      } = await getTeamTermMembers({
        variables: {
          teamTermId: parseInt(
            teamTabData[selectedTeamTab].teamTermId
          ),
        },
      });

      if (!loadingTeamTermMembers && 
          dataTeamTermMembers && 
          dataTeamTermMembers.getAllMembersInTeamTerm) {
        setAllResourceInTeamTerm(
          dataTeamTermMembers.getAllMembersInTeamTerm
        );        
      };
    }
    else
    {
      setAllResourceInTeamTerm([]);
    }
  }

  const getClientMembersList = async () => {
    if (clientId && teamTabData.length &&
        teamTabData[selectedTeamTab] && termInfo.termId)
    {
      let teamTermId = 0;
      if (teamTabData[selectedTeamTab].teamTermId)
        teamTermId = teamTabData[selectedTeamTab].teamTermId;
      
      const {
        loading: loadingClientMembers,
        error: errorClientMembers,
        data: dataClientMembers,
      } = await getClientMembers({
        variables: {
          clientId: parseInt(clientId),
          teamTermId: parseInt(teamTermId),
          termId: parseInt(termInfo.termId),
        },
      });      

      if (!loadingClientMembers && 
          dataClientMembers && 
          dataClientMembers.getClientMemberByTermAndTeam) { 
        setMembersData(
          dataClientMembers.getClientMemberByTermAndTeam
        ); 
      };
    };
  };

  const getTenantUsersList = async () => {
    if (tenantId && teamTabData.length &&
        teamTabData[selectedTeamTab] && termInfo.termId)
    {
      let teamTermId = 0;
      if (teamTabData[selectedTeamTab].teamTermId)
        teamTermId = teamTabData[selectedTeamTab].teamTermId;
      
      const {
        loading: loadingTenantUsers,
        error: errorTenantUsers,
        data: dataTenantUsers,
      } = await getTenantUsers({
        variables: {
          tenantId: parseInt(tenantId),
          teamTermId: parseInt(teamTermId),
          termId: parseInt(termInfo.termId),
        },
      });      

      if (!loadingTenantUsers && 
          dataTenantUsers && 
          dataTenantUsers.getTenantUsersByTermAndTeam) { 
        setStaffData(
          dataTenantUsers.getTenantUsersByTermAndTeam
        ); 
      };
    };
  };

  const getTermData = async () => {
    if (termUuid){
      const {
        loading: loadingTermData,
        error: errorTermData,
        data: dataTermData,
      } = await getTermDataQuery({
        variables: {
          termUuid: termUuid,
        },
      });
      if (!loadingTermData && 
        dataTermData && 
        dataTermData.getTermDataByTermUuid) {
        setTermName(dataTermData.getTermDataByTermUuid.name);
        setTermInfo(dataTermData.getTermDataByTermUuid);
      };
    };
  };

  const getTeamslist = async () => {
    if (clientId && termInfo.termId){
      const {
        loading: loadingClientTeams,
        error: errorClientTeams,
        data: dataClientTeams,
      } = await getClinetTeamsList({
        variables: {
          clientId: parseInt(clientId),
        },
      });

      const {
        loading: loadingTeamTerm,
        error: errorTeamTerm,
        data: dataTeamTerm,
      } = await getTeamTermList({
        variables: {
          termId: parseInt(termInfo.termId),
        },
      });

      if (!loadingTeamTerm && 
          dataTeamTerm && dataTeamTerm.getAllTeamsInTerm) {

        if (!loadingClientTeams && 
            dataClientTeams && dataClientTeams.allTeams) {
          let teamList = dataClientTeams.allTeams.map((item, index) => ({
            ...item,
            id: index + 1,
            addedBefore: dataTeamTerm.getAllTeamsInTerm.find(
              teamTerm => teamTerm.teamId.teamId === item.teamId)
              ? true
              : false,
            goal: dataTeamTerm.getAllTeamsInTerm.find(
              teamTerm => teamTerm.teamId.teamId === item.teamId)
              ? dataTeamTerm.getAllTeamsInTerm.find(
                teamTerm => teamTerm.teamId.teamId === item.teamId).goal !== ""
                ? dataTeamTerm.getAllTeamsInTerm.find(
                teamTerm => teamTerm.teamId.teamId === item.teamId).goal
                : ""
              : "",
            teamTermId: dataTeamTerm.getAllTeamsInTerm.find(
              teamTerm => teamTerm.teamId.teamId === item.teamId)
              ? dataTeamTerm.getAllTeamsInTerm.find(
              teamTerm => teamTerm.teamId.teamId === item.teamId).teamTermId
              : null,
          }));
          setTeamTabData(teamList);
          teamList[selectedTeamTab] &&
          setTeamGoal(teamList[selectedTeamTab].goal);
        };
      };
    };
  };

  const handleTeamTabChange = (event, newValue) => {
    const selectedMembers = 
      (membersData.filter((item) => 
        item.selected)).map(
        member => ({ 
          userId: member.clientMember.applicantId.userId.id 
        }
      ));

     const selectedStaff = 
      (staffData.filter((item) => 
        item.selected)).map(
        staff => ({ 
          userId: staff.tenantUser.userId.id 
        }
      ));

    const assignedMembers = 
      allResourceInTeamTerm.filter((item) => 
        item.userTypeId.typeName === "Member").map(
        resource => ({ userId: resource.userId.id })
      );

    const assignedStaff = 
      allResourceInTeamTerm.filter((item) => 
        item.userTypeId.typeName === "Staff").map(
        resource => ({ userId: resource.userId.id })
      );

    const areMembersDataEqual =
      JSON.stringify(
        selectedMembers.sort((x, y) => 
          Number(x.userId) - Number(y.userId))) === 
        JSON.stringify(
          assignedMembers.sort((x, y) => 
          Number(x.userId) - Number(y.userId)))

    const areStaffDataEqual =
      JSON.stringify(
        selectedStaff.sort((x, y) => 
          Number(x.userId) - Number(y.userId))) === 
        JSON.stringify(assignedStaff.sort((x, y) => 
          Number(x.userId) - Number(y.userId)))

    if (!saveToTermDone && (!areMembersDataEqual || !areStaffDataEqual)) {
      setAlertMsg({
        title: "Teams Assignment",
        type: "copyConfirmation",
        msg:
          "Are you sure you want to leave resource assignment to team “" +
          teamTabData[selectedTeamTab].name +
          "” without saving?",
        newValue: newValue,
      });
    } else {
      setTeamGoal(teamTabData[newValue].goal);
      setSelectedTab("members");
      setSelectedTeamTab(newValue);
      setSaveToTermDone(false);
      setClrResourceFlag(false);
    }
  };

  const handleListTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  
  const handleDoneEditTeamGoal = (teamGoal) => {
    let updatedList = findAnd.changeProps(
      teamTabData,
      { teamId: teamTabData[selectedTeamTab].teamId },
      {
        goal: teamGoal,            
      }
    );
    setTeamTabData(updatedList);
    setTeamGoal(teamGoal);
  };

  const handleSaveToTerm = () => {
    // Save to term
    if (!teamTabData[selectedTeamTab].addedBefore &&
      !(membersData.filter((item) => item.selected)).length && 
      !(staffData.filter((item) => item.selected)).length){
      setAlertMsg({
        title: "Save To Term",
        msg: 
          "You must assign resources to team “" +
          teamTabData[selectedTeamTab].name + 
          "” before you can assign it to the term.",
      });
      return
    }

    const newMembersErrors = {};
    membersData.forEach((member) => {
      if (member.selected && member.roleName === "") {
        newMembersErrors[member.clientMember.clientMemberId] = `You must select a role.`;
      } else delete newMembersErrors[member.clientMember.clientMemberId];
    });
    setMembersErrors(newMembersErrors);

    const newStaffErrors = {};
    staffData.forEach((staff) => {
      if (staff.selected && staff.roleName === "") {
        newStaffErrors[staff.tenantUser.tenantUserId] = `You must select a role.`;
      } else delete newStaffErrors[staff.tenantUser.tenantUserId];
    });
    setStaffErrors(newStaffErrors);
    if (
      Object.keys(newMembersErrors).length === 0 &&
      Object.keys(newStaffErrors).length === 0
    ) {
      saveTeamTermData();      
    }
  };

  const saveTeamTermData = async() => {
    // Add new team term record in DB table "team_term"
    if (!teamTabData[selectedTeamTab].addedBefore){
      if (termInfo.termId &&
          teamTabData[selectedTeamTab].teamId 
      ){
        const {
          loading: loadCreateTeamTerm,
          error: errorCreateTeamTerm,
          data: dataCreateTeamTerm,
        } = await createTeamTerm({
          variables: {
            termId: parseInt(termInfo.termId),
            teamId: parseInt(teamTabData[selectedTeamTab].teamId),
            goal: teamGoal,        
          },
        });
        if (errorCreateTeamTerm) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataCreateTeamTerm && 
          dataCreateTeamTerm.createTeamTerm) 
        {          
          updateTeamTermResources(
            dataCreateTeamTerm.createTeamTerm.teamTerm.teamTermId
          );
          // setTeamTabData(updatedList);          
        };
      };
    }
    else
    {
      if (teamTabData.length &&
          teamTabData[selectedTeamTab] &&
          teamTabData[selectedTeamTab].teamTermId) {
        
        updateTeamTermResources(
          teamTabData[selectedTeamTab].teamTermId
        );
        // setTeamTabData(updatedList);
      };        
    }
    setAlertMsg({
      title: "Team Assignment",
      msg: "Resources are successfully assigned to the team “" +
        teamTabData[selectedTeamTab].name + "”.",
    });
    setSaveToTermDone(true);
  };

  const updateTeamTermResources = (teamTermId) => {
    
    const checkedMembers = membersData.filter(
      (item) => item.selected
    );
    addEditMemberRecords(checkedMembers, teamTermId);

    const unCheckedMembers = membersData.filter(
      (item) => !item.selected
    );
    removeMemberRecords(unCheckedMembers, teamTermId);

    const checkedStaff = staffData.filter(
      (item) => item.selected
    );
    addEditStaffRecords(checkedStaff, teamTermId);

    const unCheckedStaff = staffData.filter(
      (item) => !item.selected
    );
    removeStaffRecords(unCheckedStaff, teamTermId);
  };

  const addEditMemberRecords = async(
    selectedMembers,
    teamTermId
  ) => {
    // Add new record to DB table "team_term_member" for 
    // selected members
    for (let i=0; i < selectedMembers.length; i++) {
      if (!allResourceInTeamTerm.find(
        member => 
        member.userId.id === 
        selectedMembers[i].clientMember.applicantId.userId.id))
      {
        const {
          loading: loadCreateTeamTermMember,
          error: errorCreateTeamTermMember,
          data: dataCreateTeamTermMember,
        } = await createTeamTermMember({
          variables: {
            teamTermId: parseInt(teamTermId),
            userId: parseInt(
              selectedMembers[i].clientMember.applicantId.userId.id),
            roleId: parseInt(roleData.find(role => 
              role.roleName === selectedMembers[i].roleName).roleId),
            userTypeId: parseInt(allUserTypes.find(
              userType => 
              userType.typeName === "Member").userTypeId),        
          },
        });
        if (errorCreateTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataCreateTeamTermMember && 
          dataCreateTeamTermMember.createTeamTermMember) 
        {
          console.log("Data:",
            dataCreateTeamTermMember.createTeamTermMember
          );
        };
      }
      else
      {
        // Update the existing record for this member
        const {
          loading: loadEditTeamTermMember,
          error: errorEditTeamTermMember,
          data: dataEditTeamTermMember,
        } = await editTeamTermMember({
          variables: {
            teamTermMemberId: 
            parseInt(allResourceInTeamTerm.find(
              member => 
              member.userId.id === 
              selectedMembers[i].clientMember.applicantId.userId.id).teamTermMemberId),
            roleId: parseInt(roleData.find(role => 
              role.roleName === selectedMembers[i].roleName).roleId),
          },
        });
        if (errorEditTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataEditTeamTermMember && 
          dataEditTeamTermMember.editTeamTermMember) 
        {
          console.log("EditedData:",
            dataEditTeamTermMember.editTeamTermMember
          );
        };
      }
    };
    let updatedList = findAnd.changeProps(
      teamTabData,
      { teamId: teamTabData[selectedTeamTab].teamId },
      { addedBefore: true,
        teamTermId: parseInt(teamTermId),           
      }
    );
    setTeamTabData(updatedList);
  };

  const removeMemberRecords = async(
    unSelectedMembers,
    teamTermId
  ) => {
    // Delete unchecked record from DB table "team_term_member" 
    for (let i=0; i < unSelectedMembers.length; i++) {
      if (allResourceInTeamTerm.find(
        member => 
        member.userId.id === unSelectedMembers[i].clientMember.applicantId.userId.id))
      {
        let unSelectedMember = allResourceInTeamTerm.find(
          member => 
          member.userId.id === 
          unSelectedMembers[i].clientMember.applicantId.userId.id
        );
        const {
          loading: loadDeleteTeamTermMember,
          error: errorDeleteTeamTermMember,
          data: dataDeleteTeamTermMember,
        } = await deleteTeamTermMember({
          variables: {
            teamTermMemberId: unSelectedMember.teamTermMemberId &&
              parseInt(unSelectedMember.teamTermMemberId),     
          },
        });
        if (errorDeleteTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }        
      };      
    };
    let updatedList = findAnd.changeProps(
      teamTabData,
      { teamId: teamTabData[selectedTeamTab].teamId },
      { addedBefore: true,
        teamTermId: parseInt(teamTermId),           
      }
    );
    setTeamTabData(updatedList);
  };

  const addEditStaffRecords = async(
    selectedStaff,
    teamTermId
  ) => {
    // Add new record to DB table "team_term_member" for 
    // selected staff
    for (let i=0; i < selectedStaff.length; i++) {
      if (!allResourceInTeamTerm.find(
        member => 
        member.userId.id === 
        selectedStaff[i].tenantUser.userId.id))
      {
        const {
          loading: loadCreateTeamTermMember,
          error: errorCreateTeamTermMember,
          data: dataCreateTeamTermMember,
        } = await createTeamTermMember({
          variables: {
            teamTermId: parseInt(teamTermId),
            userId: parseInt(
              selectedStaff[i].tenantUser.userId.id),
            roleId: parseInt(roleData.find(role => 
              role.roleName === selectedStaff[i].roleName).roleId),
            userTypeId: parseInt(allUserTypes.find(
              userType => 
              userType.typeName === "Staff").userTypeId),         
          },
        });
        if (errorCreateTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataCreateTeamTermMember && 
          dataCreateTeamTermMember.createTeamTermMember) 
        {
          console.log("Data:",
            dataCreateTeamTermMember.createTeamTermMember
          );
        };
      }
      else
      {
        // Update the existing record for this staff
        const {
          loading: loadEditTeamTermMember,
          error: errorEditTeamTermMember,
          data: dataEditTeamTermMember,
        } = await editTeamTermMember({
          variables: {
            teamTermMemberId: 
            parseInt(allResourceInTeamTerm.find(
              member => 
              member.userId.id === 
              selectedStaff[i].tenantUser.userId.id).teamTermMemberId),
            roleId: parseInt(roleData.find(role => 
              role.roleName === selectedStaff[i].roleName).roleId),
          },
        });
        if (errorEditTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }
        else if (dataEditTeamTermMember && 
          dataEditTeamTermMember.editTeamTermMember) 
        {
          console.log("EditedData:",
            dataEditTeamTermMember.editTeamTermMember
          );
        };
      }
    };
    let updatedList = findAnd.changeProps(
      teamTabData,
      { teamId: teamTabData[selectedTeamTab].teamId },
      { addedBefore: true,
        teamTermId: parseInt(teamTermId),           
      }
    );
    setTeamTabData(updatedList);
  };

  const removeStaffRecords = async(
    unSelectedStaffs,
    teamTermId
  ) => {
    // Delete unchecked record from DB table "team_term_member" 
    for (let i=0; i < unSelectedStaffs.length; i++) {
      if (allResourceInTeamTerm.find(
        member => 
        member.userId.id === unSelectedStaffs[i].tenantUser.userId.id))
      {
        let unSelectedStaff = allResourceInTeamTerm.find(
          member => 
          member.userId.id === 
          unSelectedStaffs[i].tenantUser.userId.id
        );
        const {
          loading: loadDeleteTeamTermMember,
          error: errorDeleteTeamTermMember,
          data: dataDeleteTeamTermMember,
        } = await deleteTeamTermMember({
          variables: {
            teamTermMemberId: unSelectedStaff.teamTermMemberId &&
              parseInt(unSelectedStaff.teamTermMemberId),     
          },
        });
        if (errorDeleteTeamTermMember) {
          setAlertMsg({
            title: "Error",
            msg: "Unfortunately an error occurred.",
          });
        }        
      };      
    };
    let updatedList = findAnd.changeProps(
      teamTabData,
      { teamId: teamTabData[selectedTeamTab].teamId },
      { addedBefore: true,
        teamTermId: parseInt(teamTermId),           
      }
    );
    setTeamTabData(updatedList);
  };

  const toggleClearResources = () => {
    if (!clrResourceFlag){
      setMembersData(
        membersData.map(item => 
          ({ ...item, selected: false })
        )
      );
      setStaffData(
        staffData.map(item => 
          ({ ...item, selected: false })
        )
      );
    }
    else
    {
      getClientMembersList();
      getTenantUsersList();
    }    
    setClrResourceFlag(!clrResourceFlag);
  }

  
  const handleCheckboxChange = (item) => {
    if (selectedTab === "members")
      setMembersData(
        membersData.map((dataItem) =>
          dataItem.clientMember.clientMemberId === item.clientMember.clientMemberId
            ? {
                ...dataItem,
                selected: !dataItem.selected,
                role: dataItem.selected ? null : dataItem.roleName,
              }
            : dataItem
        )
      );
    else
      setStaffData(
        staffData.map((dataItem) =>
          dataItem.tenantUser.tenantUserId === item.tenantUser.tenantUserId
            ? {
                ...dataItem,
                selected: !dataItem.selected,
                role: dataItem.selected ? null : dataItem.roleName,
              }
            : dataItem
        )
      );
  };  

  const handleChangeRole = (item, newValue) => {
    if (item.clientMember && 
        item.clientMember.hasOwnProperty("clientMemberId")) {
      if (membersErrors[item.clientMember.clientMemberId] && newValue !== null)
        delete membersErrors[item.clientMember.clientMemberId];
      setMembersData(
        membersData.map((dataItem) =>
          dataItem.clientMember.clientMemberId === item.clientMember.clientMemberId
            ? { ...dataItem, roleName: newValue }
            : dataItem
        )
      );
    } else {
      if (staffErrors[item.tenantUser.tenantUserId] && newValue !== null)
        delete staffErrors[item.tenantUser.tenantUserId];
      setStaffData(
        staffData.map((dataItem) =>
          dataItem.tenantUser.tenantUserId === item.tenantUser.tenantUserId
            ? { ...dataItem, roleName: newValue }
            : dataItem
        )
      );
    }
  };
  const handleOpenListOfTeam = async(item) => {
    if (selectedTab === "members") {
      let assignedTeam = [];
      assignedTeam = item.teamTermMembers.map(
        teamTermMember => 
        ({          
          teamName: teamTermMember.teamTermId.teamId.name,
          role: teamTermMember.roleId.roleName
      }));          
      setOpenListOfTeamDlg(
        {
          name: 
            item.clientMember.applicantId.userId.firstName +
            " " + 
            item.clientMember.applicantId.userId.lastName,
          assignedTeam: assignedTeam,
        },
      );
    }
    else
    {
      let assignedTeam = [];
      assignedTeam = item.teamTermMembers.map(
        teamTermMember => 
        ({          
          teamName: teamTermMember.teamTermId.teamId.name,
          role: teamTermMember.roleId.roleName
      }));          
      setOpenListOfTeamDlg(
        {
          name: 
            item.tenantUser.userId.firstName +
            " " + 
            item.tenantUser.userId.lastName,
          assignedTeam: assignedTeam,
        },
      );      
    };
  };

  const members = membersData.filter((item) => item.selected);
  const staff = staffData.filter((item) => item.selected);

  const selectedTabData = selectedTab === "members" ? membersData : staffData;
  if (loadContent)
     if (assignTeamsAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: termName, link: `${project_url}/terms/${termUuid}` },
            { label: "Teams Assignment", link: null}
          ]}
        />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Teams Assignment for Sprint: {termName}
            </Typography>
          </Box>
          <Box mt={3} mb={3}>
            <Grid container spacing={3}>
              <Grid item md={3}>
                <Card
                  className={classes.card}
                  style={{
                    paddingTop: 0,
                    minHeight: "725px",
                    maxHeight: "725px",
                    overflowY: "auto",
                    backgroundColor: "#E2F2FF",
                  }}
                >
                  <CardContent className={classes.cardContent}>
                    <Tabs
                      value={selectedTab}
                      onChange={handleListTabChange}
                      centered
                      style={{ paddingBottom: "10px" }}
                      sx={{
                        "& .MuiTabs-indicator": {
                          display: "none",
                        },
                      }}
                    >
                      <Tab
                        className={classes.resourceTabs}
                        sx={{
                          borderRadius: "4px",
                          paddingTop: "10px",
                          fontSize: "16px",
                          fontWeight: 600,
                          minWidth: "160px",
                          backgroundColor: "#fff",
                        }}
                        label="Members"
                        value="members"
                      />
                      <Tab
                        className={classes.resourceTabs}
                        sx={{
                          borderRadius: "4px",
                          fontSize: "16px",
                          fontWeight: 600,
                          minWidth: "165px",
                          backgroundColor: "#fff",
                        }}
                        label="Staff"
                        value="staff"
                      />
                    </Tabs>
                    <List>
                      {selectedTab === "members" && 
                      selectedTabData.map((item) => (
                        <ListItem 
                          key={item.clientMember.applicantId.userId.firstName} 
                          button>
                          <Checkbox
                            className={classes.checkbox}
                            checked={item.selected}
                            disabled = {item.disabled}
                            onChange={() => handleCheckboxChange(item)}
                          />
                          <StyledTooltip title="View teams for this member">
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => handleOpenListOfTeam(item)}
                              style={{ textDecoration: "none" }}
                            >
                              <ListItemText
                                primaryTypographyProps={{ fontSize: 16 }}
                                primary={`${item.clientMember.applicantId.userId.firstName} ${item.clientMember.applicantId.userId.lastName} (${
                                  item.clientMember.noOfTerms 
                                  ? item.clientMember.noOfTerms
                                  : "New"
                                })`}
                              />
                            </Link>
                          </StyledTooltip>
                        </ListItem>
                      ))}
                      {selectedTab === "staff" &&
                      selectedTabData.map((item) => (
                        <ListItem key={item.tenantUser.userId.firstName} button>
                          <Checkbox
                            className={classes.checkbox}
                            checked={item.selected}
                            disabled = {item.disabled}
                            onChange={() => handleCheckboxChange(item)}
                          />
                          <StyledTooltip title="View teams for this staff">
                            <Link
                              component="button"
                              variant="body2"
                              onClick={() => handleOpenListOfTeam(item)}
                              style={{ textDecoration: "none" }}
                            >
                              <ListItemText
                                primaryTypographyProps={{ fontSize: 16 }}
                                primary={`${item.tenantUser.userId.firstName} ${item.tenantUser.userId.lastName} (${
                                  item.tenantUser.noOfTerms 
                                  ? item.tenantUser.noOfTerms
                                  : "New"
                                })`}
                              />
                            </Link>
                          </StyledTooltip>
                        </ListItem>
                      ))}
                    </List>
                  </CardContent>
                </Card>
              </Grid>
              <Grid
                item
                md={9}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <Card className={classes.card}>
                  <CardContent className={classes.cardContent}>
                    <Grid container alignItems="center">
                      <Grid item xs={12}>
                        <Tabs
                          value={selectedTeamTab}
                          onChange={handleTeamTabChange}
                          variant="scrollable"
                          scrollButtons="auto"
                          className={classes.teamTabs}
                        >
                          {teamTabData.map((item, index) => (
                            <Tab
                              className={classes.tabs}
                              sx={{
                                borderRadius: "4px",
                                fontSize: "16px",
                                fontWeight: 600,
                                minWidth: "160px",
                              }}
                              key={item.id}
                              label={item.name}
                            />
                          ))}
                        </Tabs>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <Typography
                    variant="h3"
                    style={{ fontSize: 16, paddingTop: 10 }}
                  >
                    <b>Team Name:</b>&nbsp;{teamTabData.length &&
                      teamTabData[selectedTeamTab].name}
                  </Typography>
                  <Box pl={3}>
                    <Box className={classes.teamGoalTextBoxStyle}>
                      <Typography
                        variant="h1"
                        className={classes.teamGoalLabelTextStyle}                        
                      >
                        Team Goal:
                      </Typography>
                      <StyledTooltip title="Edit Team Goal">
                        <Typography
                          variant="h1"
                          className={classes.teamGoalTextStyle}
                          onClick={() => {
                            setOpenEditTeamGoalDialog(true);
                          }}
                        >
                          {teamGoal}
                        </Typography>
                      </StyledTooltip>
                    </Box>
                  </Box>
                  <Box>
                    <Button
                      variant="text"
                      color="primary"
                      className={classes.outlinedButtonStyle}
                      style={{ width: "145px" }}
                      disabled={
                        (!clrResourceFlag && 
                          !members.length && 
                          !staff.length
                        ) 
                        ||
                        ( 
                          !allResourceInTeamTerm.length && 
                          !members.length && 
                          !staff.length
                        )
                      }
                      // onClick={handleCancelSaveToTerm}
                      onClick={toggleClearResources}                      
                    >
                      {(clrResourceFlag && allResourceInTeamTerm.length)
                        ? "Recall Resources"
                        : "Clear Resources"
                      } 
                    </Button>
                  </Box>
                  <Grid
                    container
                    spacing={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      padding: "24px",
                      paddingTop: "4px",
                    }}
                  >
                    <Grid item md={6}>
                      <Card
                        className={classes.card}
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                        }}
                      >
                        <Typography variant="h2" style={{ fontSize: 16 }}>
                          Members
                        </Typography>
                        <List>
                          {members.map((item) => (
                            <>
                              <Grid container alignItems="center">
                                <Grid item xs={6}>
                                  <ListItem key={item.clientMember.applicantId.userId.firstName}>
                                    <ListItemText
                                      primaryTypographyProps={{ fontSize: 16 }}
                                      primary={item.clientMember.applicantId.userId.firstName + 
                                        " " + item.clientMember.applicantId.userId.lastName}
                                    />
                                  </ListItem>
                                </Grid>
                                <Grid item xs={6}>
                                  <Autocomplete
                                    className={classes.autoComStyle}
                                    key={item.clientMember.clientMemberId}
                                    value={item.roleName}
                                    disableClearable
                                    onChange={(event, newValue) => {
                                      handleChangeRole(item, newValue);
                                    }}
                                    options={roleData.map(
                                      ({ roleName }) => roleName
                                    )}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                      <TextField
                                        label="Role"
                                        margin="normal"
                                        name="role"
                                        variant="outlined"
                                        {...params}
                                        id="template"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { fontSize: 16 },
                                        }}
                                        InputLabelProps={{
                                          style: { fontSize: 16 },
                                        }}
                                        FormHelperTextProps={{
                                          style: {
                                            color: membersErrors[item.clientMember.clientMemberId]
                                              ? "red"
                                              : "transparent",
                                          },
                                        }}
                                        helperText={
                                          membersErrors[item.clientMember.clientMemberId]
                                        }
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ))}
                        </List>
                      </Card>
                    </Grid>

                    <Grid item md={6}>
                      <Card
                        className={classes.card}
                        style={{
                          maxHeight: "500px",
                          overflowY: "auto",
                        }}
                      >
                        <Typography variant="h2" style={{ fontSize: 16 }}>
                          Staff
                        </Typography>
                        <List>
                          {staff.map((item) => (
                            <>
                              <Grid container alignItems="center">
                                <Grid item xs={6}>
                                  <ListItem key={item.name}>
                                    <ListItemText
                                      primaryTypographyProps={{ fontSize: 16 }}
                                      primary={item.tenantUser.userId.firstName + 
                                        " " + item.tenantUser.userId.lastName}
                                    />
                                  </ListItem>
                                </Grid>
                                <Grid item xs={6}>
                                  <Autocomplete
                                    className={classes.autoComStyle}
                                    key={item.tenantUser.tenantUserId}
                                    value={item.roleName}
                                    disableClearable
                                    onChange={(event, newValue) => {
                                      handleChangeRole(item, newValue);
                                    }}
                                    options={roleData.map(
                                      ({ roleName }) => roleName
                                    )}
                                    getOptionLabel={(option) => option}
                                    renderInput={(params) => (
                                      <TextField
                                        label="Role"
                                        margin="normal"
                                        name="role"
                                        variant="outlined"
                                        {...params}
                                        id="template"
                                        InputProps={{
                                          ...params.InputProps,
                                          style: { fontSize: 16 },
                                        }}
                                        InputLabelProps={{
                                          style: { fontSize: 16 },
                                        }}
                                        FormHelperTextProps={{
                                          style: {
                                            color: staffErrors[item.tenantUser.tenantUserId]
                                              ? "red"
                                              : "transparent",
                                          },
                                        }}
                                        helperText={staffErrors[item.tenantUser.tenantUserId]}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </>
                          ))}
                        </List>
                      </Card>
                    </Grid>         
                    <Button
                      variant="contained"
                      color="primary"
                      className={classes.buttonStyle}
                      style={{ marginRight: 12 }}
                      onClick={handleSaveToTerm}
                    >
                      Save to Team
                    </Button>
                    <Button
                      variant="text"
                      color="primary"
                      className={classes.outlinedButtonStyle}                      
                      onClick={() => navigate(`${project_url}/terms`)}
                    >
                      Cancel 
                    </Button>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Box>

          <Grid item xs={12}>
            <Grid container justifyContent="center"></Grid>
          </Grid>
          {alertMsg.msg && alertMsg.type && (
            <AlertDialog
              title={alertMsg.title}
              type={alertMsg.type}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
              copyAction={() => {
                setMembersData(
                  membersData.map(item => 
                    ({ ...item, selected: false })
                  )
                )
                setStaffData(
                  staffData.map(item => 
                    ({ ...item, selected: false })
                  )
                )
                setSelectedTab("members");
                setClrResourceFlag(false);
                alertMsg.newValue !== null &&
                  setSelectedTeamTab(alertMsg.newValue);
                setAlertMsg([]);
              }}
            />
          )}
          {alertMsg.msg && !alertMsg.type && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
              }}
            />
          )}
          {openListOfTeamDlg && (
            <AssignedTeamDialog
              resourceType={selectedTab}
              resourcesTeamList={openListOfTeamDlg}
              closeDialog={() => setOpenListOfTeamDlg(null)}
            />
          )}
          {openEditTeamGoalDialog && (
            <EditTeamGoalDialog
              currentTeamTerm={teamTabData[selectedTeamTab]}
              teamGoal={teamGoal}
              closeDialog={() => {
                setOpenEditTeamGoalDialog(false);
              }}
              handleDone={( goal ) =>
                handleDoneEditTeamGoal( goal )
              }                  
            />
          )}
        </div>
      </div>
    );
    else 
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
};

export default TeamsAssignment;
